import * as RS from 'redux-saga';
import { AppAction, keepLocal } from 'src';
import { IActivityModel } from './Activity';
import { ActivityService } from './Activity.Service';
import { WEB_GET_ACTIVITY_DETAILS, getActivityDetailsFailedAction, setActivityDetailsAction } from './Activity.Actions';
import { AxiosResponse } from 'axios';



function* fetchActivityById(action: AppAction<any>){
    try{
        let responseData: AxiosResponse<IActivityModel>;
        if(!keepLocal){
            responseData = yield RS.effects.call(ActivityService.getActivityById, action.payload)
            yield RS.effects.put(setActivityDetailsAction(responseData.data))
            
        }
    }
    catch (e) {
        yield RS.effects.put(getActivityDetailsFailedAction(e.message))
    }
}


export function* GetActivityById(){
    yield RS.effects.takeLatest(WEB_GET_ACTIVITY_DETAILS, fetchActivityById)
} 


// WEBPACK FOOTER //
// ./src/Entities/Activity/Activity.Saga.ts